import type { IntlShape } from 'react-intl';
import type { IntlWrapper } from './intl-wrapper';

type IntlProxy = IntlWrapper & Partial<IntlShape>;

const handler: ProxyHandler<IntlWrapper> = {
  get(target: IntlProxy, prop: symbol) {
    // If the field exists in the IntlShape
    if (prop in target._intl) {
      return Reflect.get(target._intl, prop);
    }

    // If the field exists in the instance class
    if (prop in target) {
      return Reflect.get(target, prop);
    }
  },
};

const intlProxyFactory = (instance: IntlWrapper): IntlProxy => {
  return new Proxy<IntlWrapper>(instance, handler);
};

export default intlProxyFactory;
